import CustomTooltip from "app/components/Tooltip";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { ITicketTypes } from "app/types";
import React, { useEffect, useState } from "react";
import { getTicketIcon } from "../../containers/Home/containers/helpers";
import { TicketType } from "../../types";

interface CustomProps {
  type: string;
  setValue: (val: string) => void;
  ticketTypes: ITicketTypes[];
  onOpen: () => void;
  onClose: () => void;
}

const TypeSelection: React.FC<CustomProps> = ({
  type,
  setValue,
  ticketTypes,
  onOpen,
  onClose,
}) => {
  const [selectedData, setSelectedData] = useState<ITicketTypes | null>(null);

  useEffect(() => {
    if (type) {
      const selected = ticketTypes.find((x) => x._id === type);
      setSelectedData(selected as ITicketTypes);
    }
    return () => {};
  }, [type]);

  const handleSelect = (data: ITicketTypes) => {
    setSelectedData(data);
    setValue(data?._id);
  };

  return (
    <>
      <CommonTicketTypeSelection
        trigger={
          <button className="flex items-center justify-between w-full p-[6px] rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <CustomTooltip
              text="Click to choose type"
              className="flex items-center gap-1 "
              position="left"
            >
              {selectedData ? (
                <div className="flex items-center gap-1 w-full">
                  <img
                    src={getTicketIcon(selectedData?.icon as TicketType)}
                    alt="task-icon"
                    className="size-[16px]"
                  />
                  <span className={`text-xs font-normal text-secondary`}>
                    {selectedData.name}
                  </span>
                </div>
              ) : (
                <span className="text-xs leading-[18px] font-normal text-secondary">
                  Choose ticket type
                </span>
              )}
            </CustomTooltip>
          </button>
        }
        align="center"
        setValue={handleSelect}
        value={type}
        isHeader="Ticket Types"
        showEndIcon
        dropDownClassName=" min-w-[230px] "
        onOpen={onOpen}
        onClose={onClose}
      />
    </>
  );
};

export default TypeSelection;
